module.exports = __webpack_public_path__ + "img/jiaowu_mobile1.ccc2341a.jpg";